import { BaseService } from "./baseService";
class JobSitePhotoService extends BaseService {
    constructor() {
        super(...arguments);
        this.controllerName = "job_site_photo";
    }
}
export const jobSitePhotoService = new JobSitePhotoService();
//# sourceMappingURL=jobSitePhotoService.js.map